import React, { useState, useEffect } from "react"
import ApplicationService from "../../services/applications/Application.service"
import ReviewHeadExport from "./Review/License/ReviewHeadExport"

let appService = null
appService = new ApplicationService(localStorage.getItem("authUser"))

const Review = props => {
  const [viewComponent, setviewComponent] = useState()

  useEffect(() => {
    fetchApplicationDetails(props.location.search.split("=")[1])
  }, [])

  const fetchApplicationDetails = appId => {
    appService.getApplicationDetails(appId).then(response => {
      // console.log("Data", response.data)
      if (response.status) {
        //setviewComponent(<BaseApplication />)
        // if (response.data.service.id == 1) {
        //   setviewComponent(<ReviewHeadExport appDetails={response.data} />)
        // } else if (response.data.service.id == 2) {
        //   setviewComponent(<ReviewHeadExport appDetails={response.data} />)
        // } else if (response.data.service.id == 3) {
        //   setviewComponent(<ReviewHeadExport appDetails={response.data} />)
        // } else if (response.data.service.id == 4) {
        //   setviewComponent(<ReviewHeadExport appDetails={response.data} />)
        // }
        setviewComponent(<ReviewHeadExport appDetails={response.data} />)
      }
    })
  }

  return <>{viewComponent} </>
}

export default Review
